import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { libertyMOConfig } from "./data";

export default function LibertyMOPage() {
  return <CityPageTemplate config={libertyMOConfig} />;
}